import React from "react";
import Autobind from "autobind-decorator";
import * as PropTypes from "prop-types";
import ReactTable from "react-table";
import { inject, observer } from "mobx-react";
import classNames from "classnames";
import "./table-basic.css";
import "./MeasurementTable.styl";
import "./CustomScroll.styl";

/**
 * @interface MeasurementTable
 * @description Study 목록 출력 UI 컴포넌트
 * @todo
 *          - 필터 로직은 비지니스 로직 모듈로 분리하기(다음개발 계획 고려해서)
 */
@inject("sarcopeniaMeasureStore")
@observer
@Autobind
class MeasurementTable extends React.PureComponent {
  static propTypes = {
    disabled: PropTypes.bool,
  };
  static defaultProps = {
    disabled: false,
  };

  onToggleVisibility(name) {
    this.props.sarcopeniaMeasureStore.toggleVisibility(name);
  }

  /**
   * @method render
   * @description 컴포넌트 UI 렌더링
   * @returns
   * @memberof StudyViewTable
   */
  render() {
    const { disabled } = this.props;
    /// 표 컬럼 정의
    const columns = [
      {
        accessor: "visible",
        width: 40,
        Cell: (props) => {
          // props.original이 현재 row 데이터, tableContent의 인덱스 필요
          let isLastRow;
          if(sarcopeniaMeasureStore.mode ==='view')
          {
            isLastRow = props.index === tableContent.length - 1;
          }
          else
          {
            isLastRow = props.index === tableContent.length;
          }
          
          return isLastRow ? (
            <div style={{ width: 16, height: 16 }} /> // 빈 칸 또는 아이콘 대체 가능
          ) : (
            <input
              type="checkbox"
              checked={props.value}
              onChange={() => this.onToggleVisibility(props.original.name)}
            />
          );
        },
      },
      {
        accessor: "color", // String-based value accessors!
        width: 53,
        Cell: (props) => (
          <div
            className={classNames({
              "color-cell": true,
              "color-cell--disable": disabled,
            })}
            // style={{ backgroundColor: props.value }}
            style={{
              background: Array.isArray(props.value)
                ? `linear-gradient(to right, ${props.value[0]} 50%, ${props.value[1]} 50%)`
                : props.value,
            }}
          ></div>
        ),
      },
      {
        accessor: "name",
        width: 100,
        Cell: (props) => (
          <div
            className={classNames({
              "subject-cell": true,
              "subject-cell--disable": disabled,
            })}
          >
            {props.value}
          </div>
        ),
      },
      {
        accessor: "area",
        width: 80,
        Cell: (props) => <div className="measure-area-cell">{props.value}</div>,
      },
    ];

    /// 1. 입력된 dataset을 테이블에 입력할 수 있는 형태로 변환한다.
    const { dataset } = this.props;
    const { sarcopeniaMeasureStore } = this.props;
    const { _measureDatalist } = sarcopeniaMeasureStore;
    const measuredArea = sarcopeniaMeasureStore.getMeasureArea();

    const tableContent = dataset
  .map((row) => {
    const name = row["name"];
    return {
      color: row["color"],
      name,
      area: 
        sarcopeniaMeasureStore.mode === "view"
          ? measuredArea[name] : 0,
      visible:
        sarcopeniaMeasureStore.mode === "view"
          ? sarcopeniaMeasureStore._visibleMap_5Cls[name]
          : sarcopeniaMeasureStore._visibleMap_3Cls[name],
    };
  })
  .filter((row) => {
    return _.get(row, "area", "") !== "";
  });

    return (
      <React.Fragment>
        <ReactTable
          data={tableContent}
          // columns={this.columns}
          columns={columns}
          showPagination={false}
          minRows={5}
          TbodyComponent={this.customScrollbar}
          noDataText=""
        />
      </React.Fragment>
    );
  }
}

export default MeasurementTable;
